/* Codes based on the API */
export const COUNTRY_ID = {
  nl: 131, // Netherlands
  de: 45, // German
  es: 170, // Spain
  fr: 56, // France
  be: 16, // Belgium
  se: 207, // Sweden
  at: 144, // Austria
  ch: 208, // Switzerland
  uk: 198 // United Kingdom
};

export function localHostExtension(url) {
  const REGEX_LOCAL_HOST = /^yc(\w{0,4})/;
  const matchUrlExt = url.match(REGEX_LOCAL_HOST);
  if (!matchUrlExt) {
    /* localhost:3000 case */
    return 'nl';
  }
  const ycSuffix = matchUrlExt[1];

  return !ycSuffix ? 'nl' : ycSuffix;
}

export function extractUrlExtension(url = '') {
  const normalizedUrl = url.toLowerCase();

  if (
    normalizedUrl.includes('localhost') ||
    normalizedUrl.includes('staging')
  ) {
    return localHostExtension(normalizedUrl);
  }

  const REGEX_URL_EXT = /\.(\w+)$/; // matching ".nl" from the URL youngcapital.nl
  const matchUrlExt = normalizedUrl.match(REGEX_URL_EXT);

  return matchUrlExt ? matchUrlExt[1] : '';
}

export function getDefaultSelectedCountry() {
  return extractUrlExtension(window.location.host);
}

export function getDefaultSelectedCountryId() {
  const urlExtension = getDefaultSelectedCountry();
  return COUNTRY_ID[urlExtension] || '';
}
